/**
 * Модель для работы с отчётом "Физическое состояние"
 */

import { createModel } from '@rematch/core';
import { RootModel } from './index';
import { saveAs } from 'file-saver';

import { IEmployeeShort, IReportPhysicalState, IReportPhysicalStateType } from './types';
import setStartEndOfDay from '../utils/setStartEndOfDay';

import UsersService from '../services/UsersService';
import ReportService from '../services/ReportService';

interface IData {
  employees: IEmployeeShort[];
  types: IReportPhysicalStateType[];
}

interface IList {
  data: IReportPhysicalState[] | null;
  pagesCount: number;
}

interface IState {
  data: IData;
  list: IList;
}

const initialState: IState = {
  data: {
    employees: [],
    types: []
  },
  list: {
    data: null,
    pagesCount: 0
  }
};

export const reportPhysicalState = createModel<RootModel>()({
  state: initialState,
  reducers: {
    setData(state: IState, payload: IData): IState {
      return { ...state, data: payload };
    },
    setList(state: IState, payload: IList): IState {
      return { ...state, list: payload };
    },
    resetList(state: IState): IState {
      return {
        ...state,
        list: {
          data: null,
          pagesCount: 0
        }
      };
    },
    reset(): IState {
      return { ...initialState };
    }
  },
  effects: () => ({
    async getData() {
      try {
        const [{ data: employees }, { data: types }] = await Promise.all([
          UsersService.getAllEmployeesShort(),
          ReportService.getPhysicalStateTypes()
        ]);

        this.setData({ employees, types });
      } catch (error) {
        return error;
      }
    },
    async getList(params: any, rootState?: any) {
      const cloneParams = setStartEndOfDay(params, ['from', 'to']);

      try {
        const { data } = await ReportService.getPhysicalState(cloneParams);

        this.setList(data);
      } catch (error) {
        return error;
      }
    },
    async exportList(params: any, rootState?: any) {
      const { from, to } = params;

      const cloneParams = setStartEndOfDay(params, ['from', 'to']);

      try {
        const { data } = await ReportService.getCsvPhysicalState(cloneParams);

        saveAs(data, `Отчет по физическому состоянию за период ${from} - ${to}.csv`);
      } catch (error) {
        return error;
      }
    }
  })
});
